import { FULFILLMENT_TYPE } from './../../services/fulfillment.service';
import { HOOPLA_TYPE } from './../../services/thirdparty/hoopla/hoopla.service';
import { HoldService } from './../hold/hold.service';
import { BxDailog } from './dialogs/bx-dialog/bx-dailog/bx-dailog.component';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  Pipe,
  PipeTransform,
  ViewChild,
  AfterViewChecked,
  ElementRef,
  AfterViewInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { StorageService } from '../../services/storage/storage.service';
import { SharedService } from '../../services/shared/shared.service';
import { DetailsService, FULL_RECORD_OPTION_TABS } from './details.service';
import { AuthService, SYSTEMCATEGORY } from '../../services/auth/auth.service';
import { SearchService } from './../../services/search/search.service';
import { RequiredFieldDialog } from '../../components/required-field-dialog/required-field-dialog.component';
import { RequestService } from '../request/request.service';
import { BibRecordDialog } from './dialogs/bib-record-dialog/bib-record-dialog.component';
import { DetailsSnackbar } from '../../components/messages/details-snackbar/details-snackbar.component';
import { HoldingsDetailsDialog } from './dialogs/holdings-details-dialog/holdings-details-dialog.component';
import { takeUntil } from 'rxjs/operators';
import * as $ from 'jquery';
import { Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ANIMATION_MODULE_TYPE } from '@angular/platform-browser/animations';
import { DIALOG_STYLE } from '../../../assets/css/ag/styles';
import { RoutingService } from '../../services/routing/routing.service';
import { Definitions } from '../../core/definitions';
import { EContentService, ResponseMessages } from '../../services/thirdparty/econtent.service';
import { YourListService } from '../your-list/your-list.service';
import { HoldingsService } from '../../services/holdings/holdings.service';
import { IllSettingsService } from '../../services/ill-settings/ill-settings.service';
import { DashboardService, MenuItem } from '../dashboard/dashboard.service';
import { LayoutService } from '../../services/layout.service';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { AccountService } from '../account/account.service';
import { MagazineProduct, PlaceHold } from '../../services/thirdparty/overdrive/overdrive.service';
import { FulfillmentService } from '../../services/fulfillment.service';
import { SearchQuery } from '../../core/interfaces/search.interface';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { CarouselItem } from '../../components/carousel/carousel.service';
import { Sms } from '../../components/side-nav/sms/sms.component';

@Pipe({
  name: 'makeLink',
  standalone: false,
})
export class MakeLinkPipe implements PipeTransform {
  transform(value: any, args: any): any {
    if (value) {
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      if (args) {
        return value.replace(urlRegex, (url) => {
          const newUrl = url.replace(/<\/?span[^>]*>/g, '');
          return `<a href="${newUrl}" class="active-link make-link" target="_blank">${args}</a>`;
        });
      } else {
        return value.replace(urlRegex, function (url) {
          const newUrl = url.replace(/<\/?span[^>]*>/g, '');
          return `<a href="${newUrl}" class="active-link make-link" target="_blank">${newUrl}</a>`;
        });
      }
    } else {
      return value;
    }
  }
}

@Pipe({
  name: 'removeEndSpaces',
  standalone: false,
})
export class RemoveEndSpacesPipe implements PipeTransform {
  transform(value: any) {
    if (value && /\S/.test(value)) {
      return value.trim();
    }
    return value;
  }
}

@Component({
  selector: 'ag-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
  providers: [{ provide: ANIMATION_MODULE_TYPE, useValue: 'BrowserAnimations' }],
  animations: [
    trigger('fadeInOut', [
      state(
        'void',
        style({
          opacity: 0,
        }),
      ),
      transition('void <=> *', animate(250)),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DetailsComponent implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked {
  @ViewChild('myDrop') myDrop: any;
  @ViewChild('stickyBlock') stickyBlockRef: ElementRef<HTMLDivElement>;
  @ViewChild('recordButtons') recordButtonsRef: ElementRef<HTMLDivElement>;

  @Input() fromPersistentRecord = false;
  @Output() addlist = new EventEmitter<any>();
  @Output() staffRequest = new EventEmitter<any>();

  SYSTEMCATEGORY = SYSTEMCATEGORY;

  searchId: string;
  fullRecord: any;
  systemCategory: any;
  kids: boolean;
  showClcd: boolean;
  clcdLoaded: boolean;

  // OD Circulation DAta
  overDriveItem: any;

  hooplaItem: any;
  hooplaPurchaseModel: HOOPLA_TYPE;
  HOOPLA_TYPE = HOOPLA_TYPE;

  // BX variables
  BxData: any;
  canCheckOutBX: boolean;
  canHoldBX: boolean;
  canRemoveHoldBX: boolean;
  showMessageBX: boolean;
  messageTextBX: string;

  private _askEmailForHoldBX: boolean;

  // shelf browse
  shelfBrowseData: any;
  shelfLibraryValue: any = 'select a Location ----';
  shelfBrowseLocations: any;

  // variables used for ILL form
  hasGoBack: any;
  userData: any;
  showRequestThis: boolean;
  contentCafeData: any;

  loading = true;
  detailsTabLabel: string;
  moreAboutTabLabel: string;
  whereToTabLabel: string;
  marcTabLabel: string;
  shelfTabLabel: string;
  syndeticsTabLabel: string;
  novelistTabLabel: string;
  clcdTabLabel: string;
  isModify = false;
  allowPatronGuestReserve: boolean = this._holdService.allowPatronGuestReserve();
  showStaffFunctionDropdown = false;
  showFormat: boolean;
  scrolled: boolean;
  fullRecordOptionTabs = FULL_RECORD_OPTION_TABS;
  showMoreAboutThisTitle: boolean;
  showSyndeticsUnbound: boolean;
  showMoreSY: boolean;
  showFewerSY: boolean;
  showMoreCF: boolean;
  showFewerCF: boolean;
  hasNextAgControlId: boolean;
  hasPreviousAgControlId: boolean;
  showFulfillmentButton: boolean;
  fulfillmentType: FULFILLMENT_TYPE;
  fulfillmentLabel: string;
  FULFILLMENT_TYPE = FULFILLMENT_TYPE;
  shelfBrowseItems: CarouselItem[] = [];

  private _requestFormType = 'record'; // type of form for ILL request
  private _requestType = 'loan'; // type of request for ILL request
  private _highlightedText = false;
  statusCodes = new Map<string, string>();

  private _destroyed$: Subject<void> = new Subject<void>();

  openShowStaffFunctions(event: any) {
    event.stopPropagation();
    this.myDrop.open();
  }

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _yourListService: YourListService,
    private _dialog: MatDialog,
    private _authService: AuthService,
    private _detailsService: DetailsService,
    public illSettingsService: IllSettingsService,
    private _holdService: HoldService,
    private _holdingsService: HoldingsService,
    private _requestService: RequestService,
    private _router: Router,
    private _routingService: RoutingService,
    private _searchService: SearchService,
    public sharedService: SharedService,
    public storageService: StorageService,
    private _eContentService: EContentService,
    private _dashboardService: DashboardService,
    public layoutService: LayoutService,
    private _analyticsService: AnalyticsService,
    private _accountService: AccountService,
    private _fulfillmentService: FulfillmentService,
  ) {
    this.fromPersistentRecord = false;
    this.showMoreSY = false;
    this.showMoreCF = false;
    this.showFewerCF = false;
  }

  ngOnInit() {
    // Event listener after "add item to record" submit happens in the iframe
    window.addEventListener('message', this._onIframeClose);

    this._activatedRoute.queryParams
      .pipe(takeUntil(this._destroyed$))
      .subscribe(async (params: Params) => {
        const agControlId = params[Definitions.agControlIdSessionKey] || params['agcn'];
        const source = params['shard'];
        const listItemId = params['listItemId'];
        const libKey = +params['libraryDbPoolKey'] || params['key'];
        this.searchId = params['searchId'];

        this.sharedService.kidsCat$.pipe(takeUntil(this._destroyed$)).subscribe((result) => {
          this.kids = result;
        });

        if (libKey) {
          this.storageService.setItem(Definitions.libraryDbPoolSessionKey, libKey);
        }

        if (this.searchId) {
          this._searchService.hasNextAgControlId(this.searchId, agControlId).subscribe(
            (hasAgControlId) => {
              this.hasNextAgControlId = hasAgControlId;
            },
            (error: unknown) => {
              this.hasNextAgControlId = false;
              if (error instanceof Error) {
                console.error(
                  `Unable to fetch next agcontrolId for ${agControlId}: ${error.stack}`,
                );
              }
            },
          );
          this._searchService.hasPreviousAgControlId(this.searchId, agControlId).subscribe(
            (hasAgControlId) => {
              this.hasPreviousAgControlId = hasAgControlId;
            },
            (error: unknown) => {
              this.hasPreviousAgControlId = false;
              if (error instanceof Error) {
                console.error(
                  `Unable to fetch previous agcontrolId for ${agControlId}: ${error.stack}`,
                );
              }
            },
          );
        } else {
          this.hasNextAgControlId = this.hasPreviousAgControlId = false;
        }

        this.hasGoBack = this._routingService.hasBackRoute();
        this.sharedService.userData$.pipe(takeUntil(this._destroyed$)).subscribe((userData) => {
          if (!userData) {
            return;
          }

          this._getAndBindUserDataInfo(userData);
          if (listItemId) {
            this._getFullRecordByListId(listItemId, libKey);
          } else if (source) {
            this._getFullRecordByShard(agControlId, source);
          } else {
            this._getFullRecordByAgcn(agControlId, libKey);
          }
        });
      });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
    window.removeEventListener('message', this._onIframeClose);
  }

  ngAfterViewChecked() {
    // need to set bool value because ngAfterViewChecked can run multiple times
    if (!this._highlightedText) {
      this.applyHighlight();
    }
    this._highlightedText = !this._highlightedText;
  }

  private _onIframeClose = (event) => {
    const data = event.data;
    if (data == 'close') {
      this._getFullRecordByAgcn(this.fullRecord.agControlId, this.fullRecord.libraryDBPoolKey);
    }
  };

  ngAfterViewInit() {
    this.layoutService.contentScrollOffset$
      .pipe(takeUntil(this._destroyed$))
      .subscribe((offset) => {
        this.scrolled = offset !== 0;
        this.handleRecordBlockSticky(offset);
      });
  }

  applyHighlight() {
    $('#details').find('tr span').addClass('highlightText');
  }

  async goToAgControlId(type: string = 'next') {
    this.loading = true;
    let document;
    try {
      if (type == 'next') {
        document = await this._searchService
          .nextAgControlId(this.searchId, this.fullRecord.agControlId)
          .toPromise();
        if (!document) {
          this.hasNextAgControlId = false;
          return;
        }
      } else {
        document = await this._searchService
          .previousAgControlId(this.searchId, this.fullRecord.agControlId)
          .toPromise();
        if (!document) {
          this.hasPreviousAgControlId = false;
          return;
        }
      }
      this._routingService.goToFullRecord(
        document.agControlId,
        document.shard,
        this.searchId,
        document.isRefdb,
        document.refdbFullRecUrl,
      );
    } catch (error) {
      this.sharedService.openSnackBar(`Unable to fetch ${type} title.`);
      console.error(
        `Unable to get ${type} agControlId for searchId:${this.searchId} and agControlId:${this.fullRecord.agControlId}: ${error.stack}`,
      );
    } finally {
      this.loading = false;
    }
  }

  private async _getFullRecordByListId(listItemId: number, libKey: number): Promise<void> {
    this.loading = true;
    try {
      const fullRecord = await this._detailsService
        .getFullRecordByListItemId(
          this._detailsService.buildRequestPayloadFullRecordByListItemId(listItemId, libKey, false),
        )
        .toPromise();
      this._fullRecordBindings(fullRecord);
    } catch (error) {
      this._getFullRecordErrorHandler(error);
    } finally {
      this.loading = false;
    }
  }

  private async _getFullRecordByAgcn(agControlId: string, libKey: number): Promise<void> {
    this.loading = true;
    try {
      const fullRecord = await this._detailsService
        .getFullRecordByAgcn(
          this._detailsService.buildRequestPayloadFullRecordByAgcn(agControlId, libKey, false),
        )
        .toPromise();
      this._fullRecordBindings(fullRecord);
    } catch (error) {
      this._getFullRecordErrorHandler(error);
    } finally {
      this.loading = false;
    }
  }

  private async _getFullRecordByShard(agControlId: string, source: string): Promise<void> {
    this.loading = true;
    try {
      const fullRecord = await this._detailsService
        .getFullRecordByShard(
          this._detailsService.buildRequestPayloadFullRecordByShard(agControlId, source),
        )
        .toPromise();
      this._fullRecordBindings(fullRecord);
    } catch (error) {
      this._getFullRecordErrorHandler(error);
    } finally {
      this.loading = false;
    }
  }

  private _getFullRecordErrorHandler(error): void {
    this.sharedService.openSnackBar('Unable to load Full Record.');
    console.error(error);
  }

  private _isShowLibrary(): void {
    if (this.fullRecord.holdings?.groups) {
      for (let i = 0; i < this.fullRecord.holdings.groups.length; i++) {
        const group = this.fullRecord.holdings.groups[i];
        if (group.data) {
          for (let j = 0; j < group.data.length; j++) {
            const data = group.data[j];
            if (data.isMyLibrary && data.item?.length) {
              data.item[0].showLibraryText = true;
            }
          }
        }
      }
    } else if (this.fullRecord.holdings?.data) {
      for (let h = 0; h < this.fullRecord.holdings.data.length; h++) {
        const data = this.fullRecord.holdings.data[h];
        if (data.isMyLibrary && data.item?.length) {
          data.item[0].showLibraryText = true;
        }
      }
    }
  }

  openLink(link) {
    if (link.includes('http')) {
      window.open(link, '_blank');
    }
  }

  openMap(link): void {
    window.open(link, '_blank', 'location=yes,height=780,width=780,scrollbars=yes,status=yes');
  }

  private async _fullRecordBindings(fullRecord) {
    if (!fullRecord) {
      return;
    }

    this.fullRecord = fullRecord;
    this.showSyndeticsUnbound =
      fullRecord.fullRecordSettings?.displaySyndeticsUnbound &&
      fullRecord.isbn &&
      this.userData.syndeticsUnboundId;
    // check the uri if it has library bd poll key of not
    this._isShowLibrary();
    this.getShowBorrowerFormat();

    this.illSettingsService.getBorrowerPolicy().subscribe(() => {});

    this._setTabLabels();
    if (this.fullRecord.reviews) {
      this._getReviews();
    }
    if (this.fullRecord.shelfBrowseLocations) {
      this._getShelfBrowse();
    }

    // call for BX, OD, HP records
    this._getThirdPartyFullRecordIfApplicable();

    if (this.fullRecord.moreAboutThisTitleOptions) {
      this._getMoreAboutThisTitleOptions();
    }

    this.hooplaPurchaseModel = this.fullRecord.details?.fields.find(
      (d) => d.name == 'PurchaseModel',
    )?.value;

    this.showClcd = fullRecord.fullRecordSettings?.displayCLCD && fullRecord.clcdGuid;
    this._getFulfillmentInfo();
  }

  private _getFulfillmentInfo() {
    this.fulfillmentType = this._fulfillmentService.getFulfillmentType(
      this.fullRecord.targetType,
      this.fullRecord.isEContent,
      this.userData,
    );

    this.showFulfillmentButton =
      this._fulfillmentService.showFulfillmentAction(
        this.fullRecord.targetType,
        this.fullRecord.format_Short,
        this.fullRecord.hasRequestableLenders,
        this.userData,
      ) && this.fulfillmentType !== FULFILLMENT_TYPE.FULL_RECORD;

    if (this.fulfillmentType === FULFILLMENT_TYPE.ILL_REQUEST) {
      this.fulfillmentLabel = 'Request This Item';
    } else {
      this.fulfillmentLabel = this.userData.illOptions?.hasILL ? 'Request This Item' : 'Place Hold';
    }
  }

  private _;

  //#region _getShelfBrowse
  private _getShelfBrowse() {
    this.shelfBrowseLocations = this.fullRecord.shelfBrowseLocations;
    // getting the first browse shelf value from the array
    this.shelfLibraryValue = this.shelfBrowseLocations[0].locationId;
    this._callShelfBrowse();
  }
  //#endregion

  private _callShelfBrowse(): void {
    this._detailsService.shelfBrowse(this.paginationShelfBody(0)).subscribe((response) => {
      if (response.status.toLowerCase() == 'ok') {
        this.shelfBrowseItems = response.data.shelfBrowseItems.map((item) => {
          return {
            agControlId: item.agControlId,
            title: item.title,
            author: item.author,
            format: null,
            jacketArt: item.jacketArt,
            libraryDbPoolKey: item.libraryDbPoolKey,
            pubYear: item.pubYear,
            publisher: item.publisher,
            totalAvailables: item.totalAvailables,
            totalCopies: item.totalCopies,
            totalHolds: item.totalHolds,
            callNumber: item.callNumber,
          };
        });
      }
    });
  }

  private _getThirdPartyFullRecordIfApplicable(): void {
    switch (this.fullRecord.targetType.toUpperCase()) {
      case 'BX': // GET AXIS DETAILS IF APPLICABLE
        this.getDetailsBX();
        break;
      case 'OD': // GET OVERDRIVE CIRCULATION IF APPLICABLE
        this._getOverDriveCirculation();
        break;
      case 'HP':
        this.getHoopla();
        break;
    }
  }

  //#region _getReviews
  private _getReviews(): void {
    if (
      this.fullRecord.reviews.goodReadReviewData !== null &&
      this.fullRecord.reviews.goodReadReviewData
    ) {
      if (
        this.fullRecord.reviews.goodReadReviewData.divData != null &&
        this.fullRecord.reviews.goodReadReviewData.divData
      ) {
        let div = this.fullRecord.reviews.goodReadReviewData.divData;
        if (div) {
          div = div.replace('<a ', '<a target="_blank"');
          this.fullRecord.reviews.goodReadReviewData.divData = div;
        }
      }
    }
  }
  //#endregion

  private _setTabLabels(): void {
    if (this.fullRecord.fullRecordSettings?.fullRecordTabs?.length) {
      for (const element of this.fullRecord.fullRecordSettings.fullRecordTabs) {
        switch (element.value) {
          case this.fullRecordOptionTabs.Details:
            this.detailsTabLabel = element.name;
            break;
          case this.fullRecordOptionTabs.More_About_This_Title:
            this.moreAboutTabLabel = element.name;
            break;
          case this.fullRecordOptionTabs.Where_To_Find:
            this.whereToTabLabel = element.name;
            break;
          case this.fullRecordOptionTabs.MARC_Display:
            this.marcTabLabel = element.name;
            break;
          case this.fullRecordOptionTabs.Shelf_Browse:
            this.shelfTabLabel = element.name;
            break;
          case this.fullRecordOptionTabs.Syndetics_Unbound:
            this.syndeticsTabLabel = element.name;
            break;
          case this.fullRecordOptionTabs.Novelist:
            this.novelistTabLabel = element.name;
            break;
          case this.fullRecordOptionTabs.CLCD:
            this.clcdTabLabel = element.name;
            break;
        }
      }
    }
  }

  private _getMoreAboutThisTitleOptions(): void {
    // case 1: syndetics
    if (this.fullRecord.moreAboutThisTitleOptions.showSyndetics) {
      this._loadSyndetics();
    }
    // case 2: content cafe
    else if (this.fullRecord.moreAboutThisTitleOptions.showContentCafe) {
      this.contentCafeData = this.fullRecord.moreAboutThisTitleOptions.contentCafeData;
    }

    this.showMoreAboutThisTitle =
      (this.fullRecord.moreAboutThisTitleOptions?.showContentCafe ||
        this.fullRecord.moreAboutThisTitleOptions?.showSyndetics) &&
      !this.sharedService.getIsKidsCat() &&
      this.fullRecord.fullRecordSettings?.displayMoreAboutThisTitle;
  }

  //#region _loadSyndeticsAsync
  // https://medium.com/@vschroeder/javascript-how-to-execute-code-from-an-asynchronously-loaded-script-although-when-it-is-not-bebcbd6da5ea
  private _loadSyndetics(): void {
    let url = this.fullRecord.moreAboutThisTitleOptions.syndetics_Widget_URL;
    const spliceURL = '&callback=';
    if (url.includes(spliceURL)) {
      const str = url.search(spliceURL);
      url = url.substring(0, str);
      this.sharedService.addScriptToIndex('syndeticsScript', url);
    }
  }
  //#endregion

  private _getAndBindUserDataInfo(userData): void {
    this.userData = userData;
    this.showRequestThis = this.userData.illOptions.showRequestThis;
    // get System Category and accorfungky show the template for Verso and share it
    this.systemCategory = this.userData.systemCategory;
  }

  getItemHoldings(data): void {
    if (this.fullRecord.targetType == 'ZZ' || this.fullRecord.targetType == 'WM') {
      if (data.illPartNumber !== 0) {
        this._holdingsDetails(data.illPartNumber);
      } else {
        const message = 'holding details unavailable';
        this.sharedService.openSnackBar(message, 'ok');
      }
    }
    if (this.fullRecord.targetType == 'AG') {
      this._holdingsDetails(data.libraryProfileKey);
    }
  }

  private _holdingsDetails(key): void {
    this._detailsService.updateHoldingsDetails(key).subscribe((response) => {
      if (response.status == 'OK' && response.message == 'Success') {
        this.openHoldDetailsDialog(response.data);
      }
    });
  }

  openHoldDetailsDialog(data): void {
    this._dialog.open(HoldingsDetailsDialog, {
      panelClass: DIALOG_STYLE.MD,
      data: data,
    });
  }

  // more about this title show more info
  toggleShowMoreInfo(string) {
    // refresh to content cafe or show syndetics data is needed as the divs has empty values in them
    if (string == 'more') {
      this.showFewerSY = true;
      this.showMoreSY = true;
    }
    if (string == 'less') {
      this.showFewerSY = false;
      this.showMoreSY = false;
    }
  }

  toggleShowCF(string) {
    if (string == 'more') {
      this.showMoreCF = true;
      this.showFewerCF = true;
    }
    if (string == 'less') {
      this.showMoreCF = false;
      this.showFewerCF = false;
    }
  }

  holdsInQueue() {
    const link = this.fullRecord.reserveOptions.viewHoldURL;

    const menuItem: MenuItem = {
      url: link,
      fullLabel: 'Circulation > Reserves > View All Reserves',
    };

    this._dashboardService.goToMenuItem(menuItem);
  }

  actionOnShelfBrowseEvent(event) {
    if (!event.item) {
      throw new Error('item is empty');
    }
    if (event?.action) {
      switch (event.action) {
        case 'addToList':
          this.addToListFromShelf(event.item.agControlId, event.item.libraryDbPoolKey);
          break;
        case 'placehold':
          this._routingService.goToHold(event.item.agControlId);
          break;
        case 'details':
        default:
          this._routingService.goToFullRecordByAgControlId(
            event.item.agControlId,
            event.item.libraryDbPoolKey,
          );
          break;
      }
    }
  }

  // Bx - axis 360 functionality
  getDetailsBX() {
    this._detailsService.getFullDetailsBX(this.fullRecord.recordId).subscribe((response) => {
      const result: any = response;
      if (result.status == '200 OK') {
        this.BxData = result.data;
        this.canCheckOutBX = this.BxData.canCheckOut;
        this.canHoldBX = this.BxData.canHold;
        this.canRemoveHoldBX = this.BxData.canRemoveHold;
        this._askEmailForHoldBX = this.BxData.askEmailForHold;
        this.showMessageBX = this.BxData.showMessage;
        this.messageTextBX = this.BxData.messageText;
      }
    });
  }

  checkoutBX() {
    const body = {
      titleId: this.fullRecord.recordId,
      format: this.BxData.format,
      loanPeriod: this.BxData.loanPeriod,
    };
    this._detailsService.checkoutBX(body).subscribe((response) => {
      const result: any = response;
      if (result.status == '200 OK') {
        const extraMessage =
          '<br/>To read this digital book, use the Axis360 app for your mobile device. Login with your library credentials and this title will be visible. <br/>Click "Read Now" on your app to read this title.';
        this.sharedService.componentSnackbar(
          DetailsSnackbar,
          result.data.message,
          extraMessage,
          'checkout BX',
        );
        // is a get required after that? get is required to get latest as the buttons might change.
        this.getDetailsBX();
      } else {
        this.sharedService.openSnackBar('cannot checkout at this time', 'ok');
      }
    });
  }

  removeHoldBX() {
    const body = {
      titleId: this.fullRecord.recordId,
    };
    this._detailsService.removeHoldBX(body).subscribe((response) => {
      const result: any = response;
      if (result.status == '200 OK') {
        this.sharedService.openSnackBar(result.data.message, 'ok');
        this.getDetailsBX();
      } else {
        this.sharedService.openSnackBar('cannot remove hold at this time', 'ok');
      }
    });
  }

  addHoldBX() {
    let body: any;
    if (!this._askEmailForHoldBX) {
      body = {
        titleId: this.fullRecord.recordId,
      };
      this.doAddHoldBx(body);
    } else {
      // ask email in a popup
      this.openBxDialog();
    }
  }

  doAddHoldBx(body) {
    this._detailsService.addHoldBX(body).subscribe((response) => {
      const result: any = response;
      if (result.status == '200 OK') {
        this.sharedService.openSnackBar(result.data.message, 'ok');
        this.getDetailsBX();
      } else {
        this.sharedService.openSnackBar('cannot place hold at this time', 'ok');
      }
    });
  }

  // Submit request pop up ILL
  openBxDialog(): void {
    const dialogRef = this._dialog.open(BxDailog, {
      panelClass: DIALOG_STYLE.SM,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.answer == 'yes') {
        // get email and submit it to the add hold api
        const body = {
          titleId: this.fullRecord.recordId,
          email: result.email,
        };
        this.doAddHoldBx(body);
      }
    });
  }

  fulfillItem() {
    this.fulfillmentType === FULFILLMENT_TYPE.ILL_REQUEST
      ? this._requestService.requestThisItem(
          this.fullRecord.agControlId,
          this.fullRecord.libraryDBPoolKey,
          this.fullRecord.format_Short,
          this.fullRecord.sourceKey,
        )
      : this._routingService.goToHold(this.fullRecord.agControlId);
  }

  searchKey(valueKey, myArray) {
    for (let i = 0; i < myArray.length; i++) {
      if (myArray[i].value == valueKey) {
        return myArray[i];
      }
    }
    return false;
  }

  indexOf(array, value) {
    for (let i = 0; i < array.length; i++) {
      if (array[i].value == value) {
        return i;
      }
    }
  }

  goBack(): void {
    this._routingService.goBack();
  }

  doSearch(query: SearchQuery) {
    this._searchService.search(query);
  }

  //
  // email
  //
  email() {
    const userSettings = this.storageService.getUserData();
    let emailMessage;
    emailMessage = '';
    let title;

    const fields = this.fullRecord.details.fields;
    fields.forEach((item) => {
      if (item.name == 'Title' || item.name == 'title') {
        title = item.value;
      }
      emailMessage += item.name + ' : ' + item.value + '\r\n';
    });
    emailMessage += '\r\n';
    const emailData = {
      FromAddress: 'no-reply@auto-graphics.com',
      FromAddressName: userSettings.userName,
      ToAddress: '',
      CCAddress: '',
      BCCAddress: '',
      Subject: 'Full Record : ' + (title ? title : ''),
      MessageBody: emailMessage,
      IsBodyHtml: true,
    };
    // TODO: Replace with Modal Dialog so we do not need to dip into the layout.
    this.layoutService.openSideNav({ template: 'email', position: 'end', data: emailData });
  }

  print() {
    this._analyticsService.logEvent('Print Item');
    const request = {
      agControlId: this.fullRecord.agControlId,
      libraryDbPoolKey: this.fullRecord.libraryDBPoolKey,
      print: true,
    };
    this._detailsService.getFullRecordByAgcn(request).subscribe(
      (printData) => {
        this._doPrint(printData);
      },
      (error: unknown) => {
        this.sharedService.openSnackBar('Unable to get Full Record print data.');
        console.error(error);
      },
    );
  }

  private _doPrint(printData): void {
    const cid = this.storageService.getCid();
    const lid = this.storageService.getLid();
    const header =
      "<div style='text-align:center'>" +
      'Fullrecord | ' +
      cid.toUpperCase() +
      ' | ' +
      lid.toUpperCase() +
      ' | Auto-Graphics Inc. ' +
      '</div>';
    const img =
      "<div style='width:100px;height:222px;max-width:200px;'><img style='width:100%;max-width:100px;box-shadow:0px 5px 8px'" +
      "src= '" +
      printData.jacketArt.small +
      "'" +
      "default= '" +
      this._searchService.JACKETART_ERROR_URL +
      "' /></div>";
    const title =
      "<div style='margin-bottom:0px;padding-bottom:0px'><h3>" + printData.title + '</h3></div>';
    const author =
      "<div style='margin-bottom:0p;padding-bottom:0px'>" +
      '<b>Author:</b>' +
      printData.author +
      '</div>';
    const foundIn =
      "<div style='margin-bottom:0px:padding-bottom:0px'>" +
      '<b>Found In: ' +
      printData.foundIn +
      '</b></div>';
    const hr = '<div><hr></div>';
    let detailsString = '';
    for (let index = 0; index < printData.details.length; index++) {
      const element = printData.details[index];
      const dummyString =
        "<tr><th style='border:0px solid transparent;width: 120px;padding:0; text-align:left;'>" +
        element.name +
        ':</th>' +
        "<td style='border:0px solid transparent;padding:0;text-align:left;'>" +
        element.value +
        '</td></tr>';
      detailsString = detailsString.concat(dummyString);
    }
    const table = '<div><table><tbody>' + detailsString + '</tbody></table></div>';
    const mainBody =
      "<html><head><style type='text/css'></style></head><body>" +
      header +
      img +
      title +
      author +
      foundIn +
      hr +
      table +
      '</body></html>';
    const popupWin = window.open('', '_blank', 'top=0,left=0,height=80%,width=auto');
    popupWin.document.open();
    popupWin.document.write(mainBody);
    popupWin.document.close();
    popupWin.print();
    popupWin.close();
  }

  // Submit request pop up ILL
  openBibDialog(): void {
    const dialogRef = this._dialog.open(BibRecordDialog, {
      panelClass: DIALOG_STYLE.MD,
      disableClose: true,
      data: 'hello',
    });
  }

  //   ---------------------------------------------------------------------------
  //   -------------------- MULIT COPY ------------------------------------------
  //   ---------------------------------------------------------------------------
  multiCopyForm() {
    this._router.navigate(['/request'], {
      queryParams: {
        agctrlid: this.fullRecord.agControlId,
        shard: this.fullRecord.libraryDBPoolKey,
        requestType: this._requestType,
        format: this.fullRecord.format_Short,
        requestFormType: this._requestFormType,
        sourceKey: this.fullRecord.sourceKey,
        multiCopy: true,
      },
    });
  }

  //   ---------------------------------------------------------------------------
  //   -------------------- SHELF BROWSE ------------------------------------------
  //   ---------------------------------------------------------------------------
  getShelfNewLoc(value) {
    this.shelfBrowseData = null;
    this.shelfLibraryValue = value;
    this._callShelfBrowse();
  }

  selectedCarouselItem(item: CarouselItem) {
    this._routingService.goToFullRecordByAgControlId(item.agControlId, item.libraryDbPoolKey);
  }

  addToListFromShelf(agControlid, libKey) {
    if (this._authService.isGuest()) {
      this._yourListService.addItemToListFromLibKey(agControlid, libKey).subscribe((response) => {
        if (response) {
          this.sharedService.openSnackBar(response.data, 'ok');
          this._openAddToListSideNav(response.data);
        }
      });
    } else {
      const result = {
        agControlId: agControlid,
        libraryDbPoolKey: libKey,
      };
      this.addlist.emit(result);
      this._openAddToListSideNav(result);
    }
  }

  paginationShelfBody(position) {
    const result = {
      agControlId: this.fullRecord.agControlId,
      locationId: this.shelfLibraryValue,
      pageSize: this._detailsService.SHELF_PAGE_SIZE,
      startPos: position,
    };

    return result;
  }

  //   ---------------------------------------------------------------------------
  //   ------------------------ OVERDRIVE CIRCULATION  FUNCTIONS------------------
  //   ---------------------------------------------------------------------------

  refreshItem() {
    switch (this.fullRecord.targetType) {
      case 'OD':
        this._getOverDriveCirculation();
        break;
      case 'HP':
        this.getHoopla();
        break;
    }
  }

  private _getOverDriveCirculation() {
    this._eContentService.overDriveRequestItem(this.fullRecord.recordId).subscribe(
      (response) => {
        this.overDriveItem = response;
      },
      () => {
        this.sharedService.openSnackBar(ResponseMessages.GET_ITEM_ERROR, 'ok');
      },
    );
  }

  changeOverdriveJacketArt(magazineProduct: MagazineProduct): void {
    this.fullRecord.jacketArt.small = magazineProduct.images.thumbnail.href;
  }

  placeOverDriveHold() {
    this._accountService.getProfileDetails().subscribe((data) => {
      const emailField = data.data.userProfile.profileFields.find(
        (field) => field.fieldName === 'email',
      );

      if (emailField.value) {
        this._overDrivePlaceHold(this.fullRecord.recordId, emailField.value);
      } else {
        this._openOverDriveHoldDialog();
      }
    });
  }

  private _overDrivePlaceHold(productId: string, email: string) {
    const request: PlaceHold = {
      productId: productId,
      emailAddress: email,
    };

    this._eContentService.overDrivePlaceHold(request).subscribe(
      () => {
        this._getOverDriveCirculation();
        this.sharedService.openSnackBar(ResponseMessages.PLACE_HOLD_SUCCESS, 'ok');
      },
      () => {
        this.sharedService.openSnackBar(ResponseMessages.PLACE_HOLD_ERROR, 'ok');
      },
    );
  }

  private _openOverDriveHoldDialog() {
    const dialogRef = this._dialog.open(RequiredFieldDialog, {
      panelClass: DIALOG_STYLE.MD,
      data: 'Email Address',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this._routingService.goToAccountProfile();
      }
    });
  }

  //   ---------------------------------------------------------------------------
  //   ------------------------ PLACEHOLD ----------------------------------------
  //   ---------------------------------------------------------------------------
  doPlaceHold() {
    this._analyticsService.logEvent('Place Hold');
    this._routingService.goToHold(this.fullRecord.agControlId);
  }

  addToList() {
    this._analyticsService.logEvent('Add To List');
    let result: any;
    if (this._authService.isGuest()) {
      this._yourListService
        .addItemToListFromLibKey(this.fullRecord.agControlId, this.fullRecord.libraryDBPoolKey)
        .subscribe((response) => {
          if (response.status === '200 OK') {
            this.sharedService.openSnackBar(response.data, 'ok');
            this.sharedService.setLoadGuestListBS(true);
            this._openAddToListSideNav(result);
          }
        });
    } else {
      result = {
        agControlId: this.fullRecord.agControlId,
        libraryDbPoolKey: this.fullRecord.libraryDBPoolKey,
      };
      this.addlist.emit(result);
      this._openAddToListSideNav(result);
    }
  }

  sendSMS(value) {
    this._analyticsService.logEvent('Send SMS Message');
    const smsData: Sms = {
      messageBody: value,
    };
    // TODO: Replace with Modal Dialog so we do not need to dip into the layout.
    this.layoutService.openSideNav({ template: 'sms', position: 'end', data: smsData });
  }

  private _openAddToListSideNav(result) {
    this.layoutService.openSideNav({
      template: 'addList',
      position: 'end',
      data: result,
    });
  }

  // https://stackoverflow.com/questions/51658201/angular-ngif-check-if-key-exists-in-map
  // check if hyperlink exists for the each item in holdings
  //
  checkKey(item) {
    const value = item['hyperLink'];
    if (value) {
      return true;
    }
    return false;
  }

  goToAddItem() {
    this._routingService.goToAddItem(this.fullRecord.agControlId);
  }

  goToEditItem(holdingId: string) {
    this._routingService.goToEditItem(holdingId);
  }

  openIframeModule(url, fullLabel) {
    const menuItem: MenuItem = {
      url: url,
      fullLabel: fullLabel,
    };
    this._dashboardService.goToMenuItem(menuItem);
  }

  getShowBorrowerFormat() {
    this.showFormat = this.illSettingsService.showFormat(this.fullRecord.format_Short);
  }

  getHoopla(): void {
    if (!this.userData.isGuest) {
      this._eContentService.hooplaItemRequest(this.fullRecord.recordId).subscribe(
        (response) => {
          this.hooplaItem = response;
        },
        () => {
          this.sharedService.openSnackBar(ResponseMessages.GET_ITEM_ERROR, 'ok');
        },
      );
    }
  }

  showShelfStatus(resourceData) {
    const currentResource = JSON.parse(resourceData);
    this._holdingsService.getShelfStatus(resourceData).subscribe(
      (response) => {
        if (!response) {
          this.showShelfStatusError();
        } else {
          response.forEach((libraryStatus, libraryCode) => {
            this.statusCodes.set(libraryCode, libraryStatus);
          });
          if (!response.has(currentResource['LibraryCode'])) {
            this.sharedService.openSnackBar(
              this._holdingsService.UNABLE_TO_FETCH_SHELF_STATUS,
              'ok',
            );
          }
        }
      },
      (error: unknown) => {
        this.showShelfStatusError(error);
      },
    );
  }

  showShelfStatusError(error = null) {
    console.error(error);
    if (error instanceof Error) {
      this.sharedService.openSnackBar(error.message, 'ok');
    } else {
      this.sharedService.openSnackBar(this._holdingsService.UNABLE_TO_FETCH_SHELF_STATUS, 'ok');
    }
  }

  scrollToSectionById(id) {
    const pageElement = document.getElementById('page-header');
    const targetElement = document.getElementById(id);
    // Scroll to the target element
    if (targetElement) {
      // Account for Sticky Page Header
      targetElement.style.marginTop = pageElement.offsetHeight + 'px';
      targetElement.style.scrollMarginTop = pageElement.offsetHeight + 'px';
      this.sharedService.scrollIntoView(targetElement);
    }
  }

  scrollToTop() {
    this.layoutService.scrollContentToTop();
  }

  handleRecordBlockSticky(offset: number) {
    const stickyBlockElement = this.stickyBlockRef?.nativeElement;
    if (stickyBlockElement) {
      let topOffset = 0;
      if (offset > 0) {
        const containerHeight = this.layoutService
          .getContentComponent()
          .getElementRef()
          .nativeElement.getBoundingClientRect().height;
        const stickyBlockHeight = stickyBlockElement.getBoundingClientRect().height;
        if (stickyBlockHeight > containerHeight) {
          topOffset = containerHeight - stickyBlockHeight;
        }
      }
      this.stickyBlockRef.nativeElement.style.top = `${topOffset}px`;
    }
  }
}
